import { getWindowSession } from './helper';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface MigrationState {
  migrationStatus: Record<string, string>;
  setMigrationStatus: (obj: Record<string, string>) => void;
}
export const useMigrationStore = create<MigrationState>()(
  persist(
    set => ({
      migrationStatus: {},
      setMigrationStatus: (obj: Record<string, string>) =>
        set(state => ({
          migrationStatus: {
            ...state.migrationStatus,
            ...obj,
          },
        })),
    }),
    {
      name: 'migration-storage', // name of the item in storage
    }
  )
);

/**
 * set the UXL Migration Status in the session for the specific property
 */
export const setUXLMigrationStatus = (headers: Headers, propertyId?: string) => {
  const sessionObject = propertyId?.toUpperCase() ? '' : getWindowSession();
  const setMigrationStatus = useMigrationStore.getState().setMigrationStatus;
  const migrationStatus = headers.get('uxl-migration-status');

  if (migrationStatus) {
    setMigrationStatus({
      [propertyId ?? sessionObject?.cacheData?.data?.AriesReservation?.propertyId]: migrationStatus,
    });
  }
};

/**
 * get the UXL Migration Status in the session for the specific property
 *
 * @returns {String}
 */
export const getUXLMigrationStatus = (propertyId?: string) => {
  const sessionObject = propertyId?.toUpperCase() ? '' : getWindowSession();
  const migrationStatus = useMigrationStore.getState().migrationStatus;
  return migrationStatus[propertyId ?? sessionObject?.cacheData?.data?.AriesReservation?.propertyId] ?? '';
};

/**
 * set the the Migrated confirmation number in memory
 * @param headers
 */
export const setMigratedConfo = (originalConfirmation: string, migratedConfirmationNumber?: string) => {
  const setMigrationStatus = useMigrationStore.getState().setMigrationStatus;
  if (migratedConfirmationNumber) {
    setMigrationStatus({ [originalConfirmation]: migratedConfirmationNumber });
  } else {
    setMigrationStatus({ [originalConfirmation]: originalConfirmation });
  }
};

/**
 * get the Migrated Confirmation Number for migrated reservations
 *
 * @returns {string}
 */
export const getMigratedConfo = (confirmationNumber: string) => {
  const migrationStatus = useMigrationStore.getState().migrationStatus;
  return migrationStatus[confirmationNumber] ?? confirmationNumber;
};
